module.exports = "/static/images/arrow.svg";